import i18next from 'i18next'
import {SelectItem} from '@/components/dumb/Select'
import {TransactionDirection, TransactionType} from '@/stores'
export const getSelectTransactionTypesOptions = (): SelectItem[] => {
    return [
        {
            label: i18next.t('AccountTransactionsFilterForm.all'),
            value: ''
        },
        {
            label: i18next.t('AccountTransactionsFilterForm.transactionTypes.deposit'),
            value: TransactionType.deposit
        },
        {
            label: i18next.t('AccountTransactionsFilterForm.transactionTypes.withdraw'),
            value: TransactionType.withdraw
        },
        {
            label: i18next.t('AccountTransactionsFilterForm.transactionTypes.payment'),
            value: TransactionType.payment
        },
        {
            label: i18next.t('AccountTransactionsFilterForm.transactionTypes.transfer'),
            value: TransactionType.transfer
        }
    ]
}

export const getSelectDebitCreditOptions = (): SelectItem[] => {
    return [
        {
            label: i18next.t('AccountTransactionsFilterForm.all'),
            value: ''
        },
        {
            label: i18next.t('AccountTransactionsFilterForm.debitCredit.CREDIT'),
            value: TransactionDirection.CREDIT
        },
        {
            label: i18next.t('AccountTransactionsFilterForm.debitCredit.DEBIT'),
            value: TransactionDirection.DEBIT
        }
    ]
}
